import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5","key":"svg-0"}]]

const IconActivityHeartbeat = createReactComponent('outline', 'activity-heartbeat', 'ActivityHeartbeat', __iconNode);

export default IconActivityHeartbeat;